export type FilterVersion = 'v1' | 'v2'

export interface FilterVersionConfig {
  enabled: {
    v1: boolean
    v2: boolean
  }
  versionPriority: FilterVersion
  queryUpdateVersion: {
    v1: FilterVersion
    v2: FilterVersion
    default: FilterVersion
  }
}
export const FILTER_VERSION_CONFIG: FilterVersionConfig = {
  enabled: {
    v1: true,
    v2: false,
  },
  versionPriority: 'v1',
  queryUpdateVersion: {
    v1: 'v1',
    v2: 'v2',
    default: 'v1',
  },
}
